import * as THREE from 'three'
import type { CharacterPresentationFrame, CharacterPresenter } from './CharacterPresenter'

/** Presenter that keeps a character runtime active without rendering a visible proxy. */
export class InvisibleCharacterPresenter implements CharacterPresenter {
  /** Empty scene object kept for presenter lifecycle compatibility. */
  readonly object: THREE.Group
  /** No debug object is created for invisible presentation. */
  readonly debugObject: THREE.Object3D | null = null

  constructor(options: { characterId: string; sceneRoot: THREE.Object3D }) {
    this.object = new THREE.Group()
    this.object.name = `invisibleCharacterPresenter:${options.characterId}`
    this.object.visible = false
    options.sceneRoot.add(this.object)
  }

  update(frame: CharacterPresentationFrame): void {
    this.object.position.copy(frame.anchors.root.position)
    this.object.quaternion.copy(frame.anchors.root.quaternion)
    this.object.visible = false
  }

  setVisible(_visible: boolean): void {
    this.object.visible = false
  }

  dispose(): void {
    this.object.removeFromParent()
    this.object.clear()
  }
}
